import { gql } from '@apollo/client';

export const CLOSE_VISUAL_MUTATION = gql`
  mutation CloseVisual($id: Int!) {
    p {
      closeVisual(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
